var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Contentstack from 'contentstack';
import { retrieveSecrets } from './retrieveSecrets';
import { LivePreviewError } from './LivePreviewError';
import { isInLivePreviewIframe } from './isInLivePreviewIframe';
export const initStack = () => __awaiter(void 0, void 0, void 0, function* () {
    if (!isInLivePreviewIframe()) {
        return undefined;
    }
    try {
        const secrets = yield retrieveSecrets();
        return Contentstack.Stack({
            api_key: secrets.stack_api_key,
            delivery_token: secrets.delivery_token,
            environment: secrets.environment,
            region: Contentstack.Region.EU,
            branch: secrets.stack_branch || 'main',
            live_preview: {
                enable: true,
                host: 'eu-rest-preview.contentstack.com',
                management_token: secrets.live_preview_token,
            },
        });
    }
    catch (error) {
        return undefined;
    }
});
export const Stack = initStack();
export const getStack = () => __awaiter(void 0, void 0, void 0, function* () {
    const stack = yield Stack;
    if (!stack) {
        throw new LivePreviewError();
    }
    return stack;
});
//# sourceMappingURL=stack.js.map